import { render, staticRenderFns } from "./AddParameter.vue?vue&type=template&id=c5ce53ce&scoped=true"
import script from "./AddParameter.vue?vue&type=script&lang=js"
export * from "./AddParameter.vue?vue&type=script&lang=js"
import style0 from "./AddParameter.vue?vue&type=style&index=0&id=c5ce53ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ce53ce",
  null
  
)

export default component.exports